export default __webpack_public_path__ + "static/media/26.d408f439.png";